import templateUrl from './text-editor-field.html';

function frmTextEditorField() {
  return {
    restrict: 'A',
    scope: {
      required: '&',
      model: '='
    },
    templateUrl: templateUrl
  };
}

export default frmTextEditorField;



/** WEBPACK FOOTER **
 ** ./src/app/forms/fields/text-editor-field.directive.js
 **/